module.exports = __webpack_public_path__ + "static/media/tmf-group.3f5dadf4.png";